import { StepperClasskey } from "@mui/material";
import { OverridesStyleRules } from "@mui/material/styles/overrides";

export const stepperStyles: Partial<OverridesStyleRules<StepperClasskey> | undefined> = {
    root: {},
    alternativeLabel: {},
    horizontal: {},
    vertical: {},
};
